import React, { useState } from 'react';
import styled from 'styled-components';
import { LatinoTitleBold } from '..';
import { Text, TextAppearance, TextColor } from '@volkswagen-onehub/components-core';
import { CTATaigo, OptionsMobile, SlideProps } from '.';

const Div = styled.div`
  width: 100vw;
  height: var(--100vh);
  min-height: 640px;
  display: flex;
  position: relative;
  background-image: url('https://cdn.volkswagen.es/repository/app/vw-oneform/assets/images/taigo/taigo_background.png');
  background-size: cover;
  flex-direction: column;
`;

const BlueDiv = styled.div<{ isSelected: boolean; otherIsSelected: boolean }>`
  padding: ${(props) => (props.otherIsSelected ? '5%' : '0 var(--size-grid001)')};
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100vw;
  background-color: rgb(0, 130, 214, 0.6);
  display: flex;
  clip-path: ${(props) =>
    props.isSelected
      ? 'polygon(0 0, 100% 0, 100% 82%, 0 92%)'
      : props.otherIsSelected
      ? 'polygon(0 0, 100% 0, 100% 10%, 0 25%)'
      : 'polygon(0 0, 100% 0, 100% 51%, 0 50%)'};
  justify-content: ${(props) => (props.otherIsSelected ? 'flex-start' : 'center')};
  align-items: ${(props) => (props.otherIsSelected ? 'flex-start' : props.isSelected ? 'center' : 'center')};
  transition: all 0.5s ease;

  & h1 {
    font-size: ${(props) => (props.otherIsSelected ? '20px !important' : '')};
  }
`;

const RedDiv = styled.div<{ isSelected: boolean; otherIsSelected: boolean }>`
  width: 100vw;
  position: absolute;
  left: 0;
  bottom: 0;
  height: 100%;
  display: flex;
  clip-path: ${(props) =>
    props.isSelected
      ? 'polygon(0 25%, 100% 10%, 100% 100%, 0 100%)'
      : props.otherIsSelected
      ? 'polygon(0 92%, 100% 82%, 100% 100%, 0 100%)'
      : 'polygon(0 50%, 100% 50%, 100% 100%, 0 100%)'};
  justify-content: ${(props) => (props.otherIsSelected ? 'flex-end' : 'center')};
  align-items: ${(props) => (props.otherIsSelected ? 'flex-end' : 'center')};
  padding: ${(props) => (props.otherIsSelected ? '5%' : '20px var(--size-grid002)')};
  transition: all 0.5s ease;
  background-color: rgb(198, 1, 1, 0.6);

  & h1 {
    font-size: ${(props) => (props.otherIsSelected ? '20px !important' : '')};
  }
`;

const Body = styled.div<{ otherIsSelected: boolean; isSelected?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #ffffff;
  align-items: center;
`;

const BodyBlue = styled(Body)`
  padding-bottom: ${(props) => (props.isSelected ? '36px' : '0')};
  padding-top: ${(props) => (props.otherIsSelected ? '44px' : '0' )};
  height: ${(props) => (props.otherIsSelected ? '100%' : props.isSelected ? '100%' : '60%' )};
  justify-content: ${(props) => (props.otherIsSelected ? 'unset' : props.isSelected ? 'center': 'unset')};
`;

const BodyRed = styled(Body)`
  justify-content: ${(props) => (props.otherIsSelected ? 'flex-end' : props.isSelected ? 'center': 'flex-end')};
  align-items: ${(props) => (props.otherIsSelected ? 'flex-end' : 'center')};
  padding-top: ${(props) => (props.isSelected ? '28%' : '0')};
  height: ${(props) => (props.otherIsSelected ? '100%' : props.isSelected ? '100%' : '66%' )};
`;

export function FourthSlideMobile({
  blueSelected,
  setBlueSelected,
  redSelected,
  setRedSelected,
  slideConfig,
  setSelectedJourney,
  fullPageApi,
}: SlideProps) {
  return (
    <Div>
      <BlueDiv isSelected={blueSelected} otherIsSelected={redSelected}>
        {/* <Image /> */}
        <BodyBlue isSelected={blueSelected} otherIsSelected={redSelected}>
          {redSelected ? null : <LatinoTitleBold>{slideConfig.firstDivision.title}</LatinoTitleBold>}
          {blueSelected ? (
            <OptionsMobile
              setSelectedJourney={setSelectedJourney}
              subtitle={slideConfig.firstDivision.subtitle}
              options={slideConfig.firstDivision.options}
              ctaCopy="Enviar excusa"
              preButton={slideConfig.firstDivision.preButton}
              fullPageApi={fullPageApi}
              estilo='deportivo'
            />
          ) : (
            <CTATaigo
              onClick={() => {
                setBlueSelected(true);
                setRedSelected(false);
              }}
            >
              {redSelected ? 'Entrar' : 'Atrévete…'}
            </CTATaigo>
          )}
          {redSelected ? <LatinoTitleBold>{slideConfig.firstDivision.title}</LatinoTitleBold> : null}
        </BodyBlue>
      </BlueDiv>
      <RedDiv isSelected={redSelected} otherIsSelected={blueSelected}>
        {/* <RedImage /> */}
        <BodyRed isSelected={redSelected} otherIsSelected={blueSelected}>
          <LatinoTitleBold>{slideConfig.secondDivision.title}</LatinoTitleBold>
          {redSelected ? (
            <OptionsMobile
              setSelectedJourney={setSelectedJourney}
              subtitle={slideConfig.secondDivision.subtitle}
              options={slideConfig.secondDivision.options}
              preButton={slideConfig.firstDivision.preButton}
              ctaCopy="Enviar excusa"
              fullPageApi={fullPageApi}
              estilo='urbano'
            />
          ) : (
            <CTATaigo
              onClick={() => {
                setRedSelected(true);
                setBlueSelected(false);
              }}
            >
              {blueSelected ? 'Entrar' : 'Escápate ya'}
            </CTATaigo>
          )}
        </BodyRed>
      </RedDiv>
    </Div>
  );
}
